export const GREEN = '#86b302';
export const MAGENTA = '#DD176D';
export const YELLOW = '#F89815';
export const BLUE = '#0aadff';
export const CHARCOAL = '#2D2A26';

export const KPI_NEGATIVE = '#ad1313';
export const KPI_NEUTRAL = '#0f3782';
